import React, { useState } from "react";
import "./jobBoardGreen.css";
import { Link } from "react-router-dom";
import JobsGreen from "./JobsGreen";

const JobBoardGreen = () => {

  return (
    <div>
      <div className="flex flex-row bg-green-100 ">
        <div className="w-[24%] bg-green-700 p-5 sticky top-0 h-screen">
           <div className="sticky top-5">
           <h1 className="font-montserrat text-green-50 text-lg ">
            Phone: +8801 6299 646 30
          </h1>
          <div className="">
            <Link to="/">
            <h1 className=" font-marcellus text-3xl font-bold my-10 text-white">
              TUTOR TREE
            </h1>
            </Link>
          </div>

          <div className="border-b border-green-400 pb-5">
            <h1 className="text-white font-montserrat text-xl font-semibold">
              About Us
            </h1>
            <p className="text-green-50 font-roboto text-lg text-justify">
              Tutor Tree was founded in 2012. It is Bangladesh's first, most
              trusted and leading online platform for guardians, students, and
              tutors to hire verified tutors or find tuition jobs in 13
              different categories from anywhere in the country.
            </p>
          </div>
          <div className="">
            <img
              className="w-96"
              src="https://i.ibb.co/MhBFCrg/man-sits-table-with-laptop-illustration.png"
              alt=""
            ></img>
          </div>
           </div>
        </div>
        <div className="w-full flex flex-col ">
          <div className="">
            <div className="w-full py-4 px-6 bg-green-100 flex justify-end ">
              <div className="flex justify-center items-center flex-row gap-4">
                <Link className="text-green-900 font-roboto text-lg">
                  Sign In
                </Link>
                <Link className="text-green-900 font-roboto text-lg">
                  Job Board
                </Link>
                <Link className="text-white font-roboto text-lg px-4 py-2 rounded-xl bg-green-700 hover:bg-green-900 text-whit duration-300">
                  Become a tutor
                </Link>
              </div>
            </div>
            <JobsGreen ></JobsGreen>
            
       
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobBoardGreen;
